import { forwardRef } from "react";
// a nice library for country names and codes :)
import countries from "i18n-iso-countries";
import FormSelect from "components/Forms/FormSelect";

// Register the languages you want to use
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

function SelectCountry({ placeholder, ...props }, ref) {
  return (
    <FormSelect {...props} ref={ref} placeholder={placeholder || "Select country"}>
      {Object.entries(countries.getNames("en")).map(([code, name]) => (
        <option key={code} value={code}>
          {name}
        </option>
      ))}
    </FormSelect>
  );
}

export default forwardRef(SelectCountry);
